var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass:
        "\n    f-loader\n    fixed\n    top-0\n    left-0\n    right-0\n    bottom-0\n    flex\n    items-center\n    justify-center\n    z-50\n    bg-velux-grey-900 bg-opacity-70\n  "
    },
    [
      _c(
        "div",
        { staticClass: "-mt-40 mx-auto mb-10 w-full text-center p-10" },
        [
          _c("div", { staticClass: "w-40 h-40 mx-auto" }, [
            _c(
              "svg",
              {
                staticClass: "animate-spin m-0 mx-auto",
                attrs: {
                  width: "104",
                  height: "104",
                  viewBox: "0 0 104 104",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d:
                      "M52 104C80.7188 104 104 80.7188 104 52C104 23.2812 80.7188 0 52 0C23.2812 0 0 23.2812 0 52C0 80.7188 23.2812 104 52 104ZM52 92C74.0918 92 92 74.0914 92 52C92 29.9086 74.0918 12 52 12C29.9082 12 12 29.9086 12 52C12 74.0914 29.9082 92 52 92Z",
                    fill: "white"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d:
                      "M52 104C80.7188 104 104 80.7188 104 52H92C92 74.0914 74.0918 92 52 92V104Z",
                    fill: "#EE0000"
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "f-loader__text" }, [_vm._t("default")], 2)
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }